import { render } from "./badge.vue?vue&type=template&id=3bdbff0f"
import script from "./badge.vue?vue&type=script&setup=true&lang=js"
export * from "./badge.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/components/badge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bdbff0f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bdbff0f', __exports__)) {
    console.log('reload')
    api.reload('3bdbff0f', __exports__)
  }
  
  module.hot.accept("./badge.vue?vue&type=template&id=3bdbff0f", () => {
    console.log('re-render')
    api.rerender('3bdbff0f', render)
  })

}


export default __exports__